// Mantine
import { ActionIcon, NumberInput, Anchor, Tooltip, Modal } from '@mantine/core'

// Icons
import {
    IconTrash,
    IconPhotoOff,
    IconCalendar,
    IconX,
} from '@tabler/icons-react'

// Dayjs
import dayjs from 'dayjs'

// React
import { useState } from 'react'

export default function VariantLine({
    line,
    onRemove,
    onPriceChange,
    onQuantityChange,
    hidePrice = false,
}) {
    // Price edit modal
    const [isPriceEditModalOpen, setIsPriceEditModalOpen] = useState(false)

    return (
        <>
            <div className="grid grid-cols-[60px_1fr_100px] items-center gap-5 py-2">
                <div className="aspect-square h-[60px] bg-gray-100 rounded-lg relative">
                    {line.image ? (
                        <img
                            src={line.image + '&width=100'}
                            className="w-full h-full p-2 object-contain"
                            alt={line.product_title}
                        />
                    ) : (
                        <div className="flex items-center justify-center w-full h-full text-gray-400">
                            <IconPhotoOff size="1.5rem" />
                        </div>
                    )}
                </div>

                <div className="flex flex-col items-start">
                    <Anchor
                        href={`/products/shopify/${line.product_id}`}
                    >
                        {line.product_title}
                    </Anchor>

                    <div className="flex gap-2 items-center">
                        {line.variant_title !== 'Default Title' && (
                            <span className="text-gray-500">
                                {line.variant_title}
                            </span>
                        )}

                        <span className="text-gray-400 hidden">{line.sku}</span>
                    </div>

                    <div className="mt-1">
                        <Anchor
                            size="sm"
                            onClick={() => setIsPriceEditModalOpen(true)}
                        >
                            {new Intl.NumberFormat('fr-FR', {
                                style: 'currency',
                                currency: 'EUR',
                            }).format(line.unit_price)}
                        </Anchor>
                    </div>

                    {false && line.dispatch_date && (
                        <Tooltip
                            label="Date d'expédition habituellement prévue"
                            position="top"
                        >
                            <span className="text-orange-400 text-sm flex items-center gap-1 mt-2">
                                <IconCalendar size="1rem" />
                                {dayjs(line.dispatch_date).format('ll')}
                            </span>
                        </Tooltip>
                    )}
                </div>

                <div className="flex gap-2 justify-end items-start">
                    <div className="flex flex-col gap-2 items-center">
                        <div className="flex items-center gap-2">
                            <NumberInput
                                clampBehavior="strict"
                                min={1}
                                w={100}
                                value={line.quantity}
                                prefix="×"
                                onChange={(value) => onQuantityChange(value)}
                            />
                        </div>
                        {line.availableAtLocation >= 999 && (
                            <span className="text-gray-500 text-xs">
                                999+ disponible(s)
                            </span>
                        )}

                        {line.availableAtLocation > 0 &&
                            line.availableAtLocation < 999 && (
                                <span className="text-gray-500 text-xs">
                                    {line.availableAtLocation} disponible(s)
                                </span>
                            )}

                        {line.availableAtLocation <= 0 && (
                            <span className="text-red-500 text-xs">
                                Non disponible
                            </span>
                        )}
                    </div>

                    <ActionIcon
                        size="lg"
                        variant="subtle"
                        color="dark"
                        onClick={() => onRemove()}
                    >
                        <IconX size="1rem" />
                    </ActionIcon>
                </div>
            </div>

            <Modal
                opened={isPriceEditModalOpen}
                onClose={() => setIsPriceEditModalOpen(false)}
                title="Modifier le prix"
            >
                <NumberInput
                    min={0.01}
                    decimalScale={2}
                    fixedDecimalScale
                    clampBehavior="strict"
                    suffix=" €"
                    value={line.unit_price}
                    decimalSeparator=","
                    thousandSeparator=" "
                    onChange={(value) => onPriceChange(value)}
                />
            </Modal>
        </>
    )
}
